<template>
  <div>
    <el-row>
      <el-col :span="24" class="top-title">
        <div>
          班级资源
        </div>
        <div class="change-class-box">
            <el-select v-model="form.class_guid" placeholder="请选择" @change="changeClass">
                <el-option
                v-for="item in classList"
                :key="item.class_guid"
                :label="item.class_name"
                :value="item.class_guid">
                </el-option>
            </el-select>
        </div>
      </el-col>
      <el-col :span="18" :offset="3" class="examination-box">
        <el-tabs
          type="border-card"
          style="min-height:80vh"
          v-model="form.type"
          @tab-click="clickTabChangeFlag"
        >
          <el-tab-pane label="微课" name="VIDEO">
            <el-row>

              <div v-if="list.length !== 0">
                <el-col :span="12" v-for="(item, index) in list" :key="index">
                  <div class="work-box">
                    <el-card class="box-card">
                      <div class="title-box">
                        <div class="work-title" @click="showSourceDetail(item)">
                          {{ item.sources_name }}
                        </div>
                        <div class="complete-btn">
                          <el-button
                            v-if="item.complete_flag == 'Y'"
                            type="info"
                            size="mini"
                            >已学</el-button
                          >
                          <el-button
                            v-if="item.complete_flag == 'N'"
                            type="danger"
                            size="mini"
                            >未学</el-button
                          >
                        </div>
                      </div>

                      <el-row>
                        <el-col :span="6">
                          <div class="work-img-div">
                            <img
                              :src="
                                logoList[item.type]
                                  ? logoList[item.type]
                                  : defaultLogo
                              "
                              style="width:70%"
                              alt=""
                            />
                          </div>
                        </el-col>
                        <el-col :span="12" class="work-desc">
                          <div class="work-start-time">
                            {{ item.createtime }}
                          </div>
                          <div class="work-teacher-name">
                            {{ item.real_name }}
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <template>
                            <div class="work-show-btn">
                              {{ item.click_num }}人已学习
                            </div>
                          </template>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div>
                </el-col>
              </div>
              <div v-else>
                  <el-empty description="暂无数据" :image-size="300"></el-empty>
              </div>



            </el-row>
          </el-tab-pane>
          <el-tab-pane label="专辑" name="ALBUM">
            <el-row>
              <div v-if="list.length !== 0">
                <el-col :span="12" v-for="(item, index) in list" :key="index">
                  <div class="work-box">
                    <el-card class="box-card">
                      <div class="title-box">
                        <div class="work-title" @click="showSourceDetail(item)">
                          {{ item.album_name }}
                        </div>
                        <div class="complete-btn">
                          <el-button
                            type="warning"
                            size="mini"
                            >{{item.complete_cnt}} / {{item.source_cnt}}</el-button
                          >
                        </div>
                      </div>

                      <el-row>
                        <el-col :span="6">
                          <div class="work-img-div">
                            <img
                              :src="
                                logoList[item.type]
                                  ? logoList[item.type]
                                  : defaultLogo
                              "
                              style="width:70%"
                              alt=""
                            />
                          </div>
                        </el-col>
                        <el-col :span="12" class="work-desc">
                          <div class="work-start-time">
                            {{ item.createtime }}
                          </div>
                          <div class="work-teacher-name">
                            {{ item.real_name }}
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <template>
                            <div class="work-show-btn">
                              {{ item.view_cnt }}人已学习
                            </div>
                          </template>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div>
                </el-col>
              </div>
              <div v-else>
                  <el-empty description="暂无数据" :image-size="300"></el-empty>
              </div>

            </el-row>
          </el-tab-pane>
          <el-tab-pane label="音频" name="AUDIO">
            <el-row>
              <div v-if="list.length !== 0">
                <el-col :span="12" v-for="(item, index) in list" :key="index">
                  <div class="work-box">
                    <el-card class="box-card">
                      <div class="title-box">
                        <div class="work-title" @click="showSourceDetail(item)">
                          {{ item.sources_name }}
                        </div>
                        <div class="complete-btn">
                          <el-button
                            v-if="item.complete_flag == 'Y'"
                            type="info"
                            size="mini"
                            >已学</el-button
                          >
                          <el-button
                            v-if="item.complete_flag == 'N'"
                            type="danger"
                            size="mini"
                            >未学</el-button
                          >
                        </div>
                      </div>

                      <el-row>
                        <el-col :span="6">
                          <div class="work-img-div">
                            <img
                              :src="
                                logoList[item.type]
                                  ? logoList[item.type]
                                  : defaultLogo
                              "
                              style="width:70%"
                              alt=""
                            />
                          </div>
                        </el-col>
                        <el-col :span="12" class="work-desc">
                          <div class="work-start-time">
                            {{ item.createtime }}
                          </div>
                          <div class="work-teacher-name">
                            {{ item.real_name }}
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <template>
                            <div class="work-show-btn">
                              {{ item.click_num }}人已学习
                            </div>
                          </template>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div>
                </el-col>
              </div>
              <div v-else>
                  <el-empty description="暂无数据" :image-size="300"></el-empty>
              </div>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="课件" name="COURSEWARE">
            <el-row>
              <div v-if="list.length !== 0">
                
                <el-col :span="12" v-for="(item, index) in list" :key="index">
                  <div class="work-box">
                    <el-card class="box-card">
                      <div class="title-box">
                        <div class="work-title" @click="showSourceDetail(item)">
                          {{ item.sources_name }}
                        </div>
                        <div class="complete-btn">
                          <el-button
                            v-if="item.complete_flag == 'Y'"
                            type="info"
                            size="mini"
                            >已学</el-button
                          >
                          <el-button
                            v-if="item.complete_flag == 'N'"
                            type="danger"
                            size="mini"
                            >未学</el-button
                          >
                        </div>
                      </div>

                      <el-row>
                        <el-col :span="6">
                          <div class="work-img-div">
                            <img
                              :src="
                                logoList[item.type]
                                  ? logoList[item.type]
                                  : defaultLogo
                              "
                              style="width:70%"
                              alt=""
                            />
                          </div>
                        </el-col>
                        <el-col :span="12" class="work-desc">
                          <div class="work-start-time">
                            {{ item.createtime }}
                          </div>
                          <div class="work-teacher-name">
                            {{ item.real_name }}
                          </div>
                        </el-col>
                        <el-col :span="6">
                          <template>
                            <div class="work-show-btn">
                              {{ item.click_num }}人已学习
                            </div>
                          </template>
                        </el-col>
                      </el-row>
                    </el-card>
                  </div>
                </el-col>
              </div>
              <div v-else>
                  <el-empty description="暂无数据" :image-size="300"></el-empty>
              </div>


            </el-row>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <Waterfall
      ref="Waterfall"
      :dataList="dataList"
      :list="list"
      :form="form"
    ></Waterfall>

    <VideoShow ref="VideoShow"  />
    <AudioShow ref="AudioShow"  />
    <AlbumShow ref="AlbumShow"  />
  </div>
</template>

<script>
import { SourceShareList, classMemberList } from "@/api";
import store from "@/store";
import Waterfall from "@/components/waterfall";
import VideoShow from "@/components/videoShow";
import AudioShow from "@/components/audioShow";
import AlbumShow from "@/components/albumShow";

export default {
  name: "ClassSource",
  components: {
    Waterfall, VideoShow, AudioShow, AlbumShow
  },
  props: ["cate", "words"],
  data() {
    return {
      classPopver: false,
      dialogVisible: false,
      source_prefix:process.env.VUE_APP_UPYUN_PATH,
      list: [],
      classList:[],
      listForm:{
              'page':1,
              'limit':99,
              'where':{}
      },
      form: {
        page: 1,
        limit: 10,
        type: "VIDEO",
        class_guid: "",
      },
      defaultLogo:
        "http://foo.ibianma.com/jingying/word/2022/12/07/648fc8e957105cde7bf8e9aae4c946e6.png",
      logoList: {
        "VIDEO":
          "http://foo.ibianma.com/jingying/word/2022/12/07/648fc8e957105cde7bf8e9aae4c946e6.png", //课件
        "ALBUM":
          "http://foo.ibianma.com/jingying/word/2022/12/07/a66ad393d0651ba0c3341d4af4a66afd.png", //题库作业
        "AUDIO":
          "http://foo.ibianma.com/jingying/word/2022/12/07/c3671ce095c5d489eedefd409b578c90.png", //音频
        "COURSEWARE":
          "http://foo.ibianma.com/jingying/word/2022/12/07/0bdb0335ede0c79d10e55ad67405ba20.png", //课件
      },
    };
  },
  computed: {},
  methods: {
    dataList(trueType) {

      if(trueType == true)
      {
        this.list = []
        this.form.page = 1
      }
      SourceShareList(this.form).then((response) => {
        if (response.data.length != 0) {
          this.list = this.list.concat(response.data);
          this.$refs.Waterfall.isLoading = false;
        }
      });
    },
    changeClass()
    {

        var class_guid = this.form.class_guid
        var userInfo = this.$store.state.user.userInfo
        userInfo.class_guid = class_guid
        
        store.dispatch('user/setUserInfoData', userInfo);
        this.dataList(true)
    },
    classMemberList()
    {
        classMemberList(this.listForm).then(response => {
            this.classList = response.data
        })

    },
    showSourceDetail(e)
    {
        switch(e.type) {
            case 'VIDEO':
                var a = this.source_prefix + e.sources_url
                this.$refs.VideoShow.show(this.source_prefix + e.sources_url)
                break;
            case 'ALBUM':
                this.$refs.AlbumShow.show(e)
                break;
            case 'AUDIO':
                var a = this.source_prefix + e.sources_url
                this.$refs.AudioShow.show(e)
                break;
                
            case 'COURSEWARE':
              var url = this.source_prefix + e.sources_url
              // window.location.href=url
              window.open(url) 
            break;
            default:
                
        } 
    },
    clickTabChangeFlag() {
      
      this.dataList(true);
    },
    showReport(e) {

      if (e.report_list_flag == "Y") {
        this.$router.push({
          path: "/viewreport",
          query: { work_guid: e.work_guid },
        });
      } else {
        this.$notify.success({
          title: "信息提示",
          message: e.report_unavailable_msg,
          duration: 3000,
        });
      }
    },
    startWork(e) {
      this.$router.push({
        path: "/homeworkanswer",
        query: { work_guid: e.work_guid },
      });
    },
  },
  mounted() {

    this.form.class_guid = this.$route.query.class_guid;
    this.dataList();
    this.classMemberList()
  },
};
</script>
<style scoped lang="less">
    .change-class-box{
        text-align: right;
        padding-right: 14%;
    }
.top-title {
  text-align: center;
  font-size: 24px;
  margin-top: 1vh;
}

.examination-box {
  margin-top: 5vh;
}

.work-box {
  padding: 30px;
}

.title-box {
  padding-bottom: 10px;
  display: flex;
}

.work-title {
  font-size: 20px;
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
.complete-btn {
  width: 20%;
  text-align: right;
}

.work-start-time {
  margin-top: 20px;
}

.work-teacher-name {
  margin-top: 15px;
}

.work-img-div {
  padding: 10px;
}

.work-show-btn {
  font-size: 15px;
  color: #409eff;
  cursor: pointer;
  margin-top: 6vh;
}

.work-desc {
  font-size: 18px;
}

@media (max-width: 1400px) {
  .work-desc {
    font-size: 14px;
  }
}
</style>
